// 匹配字典表 名称
function matchCodeName(codeName, codeValue) {
    const codeData = JSON.parse(localStorage.getItem('codeData'))
    const codes = codeData[codeName]
    const code = codes.filter(item => item.itemValue === codeValue)
    return code[0] ? code[0].itemName : ''
}

// 匹配字典表 集合
function matchCode(codeName) {
    const codeData = JSON.parse(localStorage.getItem('codeData'))
    const codes = codeData[codeName]
    return codes
}

const Fn = {
    matchCodeName,
    matchCode
}

export default Fn
